<template>
  <CoreTextComponent
    :string="block?.current_locale"
    :class="[$style.root, viewOptionClass]"
  />
</template>

<script setup>
const props = defineProps({
  block: Object
})

const viewOptionClass = computed(() => {
  return props?.block?.view_option === 'small' ? 'font-size-small' : 'font-size-default'
})
</script>

<style module>
.root {
  composes: container--medium from global;

  font-family: 'routed-gothic';
}

.root:global(.font-size-default) {
  font-size: calc(var(--font-default--font-size) * .95);
  line-height: calc(var(--font-default--line-height) * 1.025);
  letter-spacing: var(--font-default--letter-spacing);
}
</style>
